export default "__VITE_ASSET__oImMzVm2__"